const OneColumRow = ({ children }) => {
   return (
     <div className="one-colum-row">
       {children}
     </div>
   );
 };
 
 export default OneColumRow;